import React, { Component } from 'react'
import { Card } from 'react-bootstrap';

class PrefacturaGeneralInfo extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-black card-label-info">Versión: </strong>
          { data.field?.input?.Version }
          <br/>

          { data.status === 1 && (
            <>
              <strong className="text-black card-label-info">Folio Fiscal: </strong>
              { data.uuid }
              <br/>
            </>
          )}

          <strong className="text-black card-label-info">Emisor: </strong>
          { data.emisor_rfc } { data.emisor_razon_social || '' }
          <br/>

          <strong className="text-black card-label-info">Receptor: </strong>
          { data.receptor_rfc } { data.receptor_razon_social || '' }
          <br/>

          { !!data.serie && (
              <span>
                <strong className="text-black card-label-info">Serie: </strong>
                { data.serie }
                <br/>
              </span>
            )
          }

          { !!data.folio && (
              <span>
                <strong className="text-black card-label-info">Folio: </strong>
                { data.folio }
                <br/>
              </span>
            )
          }

          <br />

          <strong className="text-black card-label-info">Subtotal: </strong>
          { data.subtotal }
          <br />

          <strong className="text-black card-label-info">Descuento: </strong>
          { data.descuento || '0.00' }
          <br />

          <strong className="text-black card-label-info">Retenciones: </strong>
          { data.field?.input?.Impuestos?.TotalImpuestosRetenidos || '0.00' }
          <br />

          <strong className="text-black card-label-info">Traslados: </strong>
          { data.field?.input?.Impuestos?.TotalImpuestosTrasladados || '0.00' }
          <br />

          <strong className="text-black card-label-info">Total: </strong>
          { data.total }
          <br/>
        </Card.Body>
      </Card>
    )
  }
}

export default PrefacturaGeneralInfo;